<template>
  <v-dialog v-model="dialogIsOpen" max-width="300" :persistent="true">
    <v-card class="dialog-box home-form-container building_structure_dialog">
      <v-card-title class="headline">
        {{ $t('BuildingStructure') }}
      </v-card-title>

      <v-card-text style="padding-bottom: 10px; white-space: normal">
        {{ $t('DefineBuildingStructure') }}
      </v-card-text>

      <input-field
        :label="$t('GroundFloors')"
        size="medium"
        v-model="nrGroundFloors"
        input-type="int"
        min="1"
        :required="true"
      />

      <input-field
        :label="$t('UndergroundFloors')"
        size="medium"
        v-model="nrUndergroundFloors"
        input-type="int"
        min="0"
        :required="true"
      />

      <input-field
        :label="$tc('Fraction', 2)"
        size="medium"
        v-model="nrFractionsPerFloor"
        input-type="int"
        min="1"
        :required="true"
      />

      <v-card-actions>
        <v-btn
          @click="$emit('close-dialog')"
          :ripple="false"
          class="secondary-button"
          text
        >
          {{ $t("Cancel") }}
        </v-btn>
        <v-btn
          @click="$emit('preview-building', {
            groundFloors: parseInt(nrGroundFloors),
            undergroundFloors: parseInt(nrUndergroundFloors),
            fractions: parseInt(nrFractionsPerFloor)
          })"
          :ripple="false"
          class="main-button"
          text
        >
          {{ $t("Create") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";

export default {
  name: "BuildingStructureDialog",

  components: {
    InputField
  },

  props: {
    dialogIsOpen: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      nrGroundFloors: 1,
      nrUndergroundFloors: 1,
      nrFractionsPerFloor: 1
    }
  }
}
</script>

<style>
.building_structure_dialog .input-field label {
  text-align: left;
  font-size: 12px;
}

.building_structure_dialog input, .building_structure_dialog textarea{
  background-color: var(--v-secondary-lighten1) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/BuildingStructureDialog.vue